/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type api_v2_analytics_choices_ColumnOption = {
    default?: boolean;
    deletable?: boolean;
    id?: string;
    label?: string;
    type?: api_v2_analytics_choices_ColumnOption.type;
};
export namespace api_v2_analytics_choices_ColumnOption {
    export enum type {
        STRING = 'String',
        PRICE = 'Price',
        PERCENTAGE = 'Percentage',
        NUMBER = 'Number',
    }
}

